import React, { Fragment } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default ({ fullScreen, color, align, ...restProps }) => {
  let style = {
    textAlign: align || "center"
  };

  if (fullScreen) {
    style = {
      position: "fixed",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
  }

  return (
    <div style={style}>
      <CircularProgress style={{ color: color || "#044761" }} {...restProps} />
    </div>
  );
};
